module.exports = __webpack_public_path__ + "img/luna creciente.863eb8e8.png";